var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"mb-3 hp-text-color-black-1"},[_vm._v("Статистика")]),_c('StatsTable',{attrs:{"is_admin":_vm.is_admin}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }